import { forwardRef } from "react";
import { InputMask, type InputMaskProps } from "@react-input/mask";

export const CPFMask = forwardRef<HTMLInputElement, InputMaskProps>(
  function CPFMask(props, ref) {
    const { ...other } = props;
    return (
      <InputMask
        ref={ref}
        mask="___.___.___-__"
        replacement={{ _: /\d/ }}
        {...other}
      />
    );
  }
);
